import { useCallback } from 'react';
import { RootState } from 'store';

import { useSelector } from 'react-redux';
import { STATIONS_STATE } from 'entities/stations';
import { Station } from 'dataSources/Typicode/stations';

export const useSelectedStationOnRoute = () => {
  const selectedStationOnRoute = useSelector((state: RootState) => state[STATIONS_STATE].selectedStation.data);
  return selectedStationOnRoute;
};

export const useSelectedRouteStationCodes = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].selectedStation.data)
);

export const useIsStationSelected = () => {
  const selectedStationOnRoute = useSelectedStationOnRoute();

  const isStationSelected = useCallback(
    (station: Station) => {
      if (!selectedStationOnRoute || !Array.isArray(selectedStationOnRoute)) return false;
      return selectedStationOnRoute.includes(station.code);
    },
    [selectedStationOnRoute]
  );

  return isStationSelected;
};

export const useCheckIsSelectedStationOnRoute = () => {
  const selectedStationOnRoute = useSelectedStationOnRoute();

  const checkIsSelectedStationOnRoute = useCallback(
    (stationCode: Station['code']) => {
      if (!selectedStationOnRoute || !Array.isArray(selectedStationOnRoute)) return false;
      return selectedStationOnRoute.includes(stationCode);
    },
    [selectedStationOnRoute]
  );

  return checkIsSelectedStationOnRoute;
};
